export const TRANSLATION_SCOPE = 'questionnaireGroupModule';
export const TRANSLATION_GRID_SCOPE = [TRANSLATION_SCOPE, 'grid'];
export const TRANSLATION_CRUD_SCOPE = [TRANSLATION_SCOPE, 'crud'];
